<template>
	<div class="header">
		<div class="center">
			<router-link class="logo" to="/personal">{{system_web_name}}</router-link>
			<div class="logout" v-if="!isLogin && is_nouser_version == 0 && is_haveteam_version == 1">
				<a @click="loginPer">个人登录</a>
			</div>
			<div class="logout" v-if="!isLogin && is_nouser_version == 0 && is_haveteam_version != 1">
				<a @click="loginPer">个人登录</a>
			</div>
			<div class="logout" v-if="is_nouser_version == 1 && is_haveteam_version == 1 && !isLoginTeam">
				<router-link to="/personal/orderrecord">订单记录</router-link>
			</div>
			<div class="logout" v-if="is_nouser_version == 1 && is_haveteam_version == 1 && isLoginTeam">
				<router-link to="/personal/orderrecord">订单记录</router-link>
				<router-link to="/team/list">历史订单</router-link>
				<span>|</span>
				<a @click="modifypwd">修改密码</a>
				<span>|</span>
				<router-link to="/team/info">{{ team_nickname }}</router-link>
				<span>|</span>
				<a @click="logout">退出登录</a>
			</div>
			
			
			<div class="logout" v-if="is_nouser_version == 1 && is_haveteam_version == 0">
				<a @click="$router.push('/personal/orderrecord')">订单记录</a>
			</div>
			<div class="login" v-if="isLogin && is_nouser_version == 0">
				<router-link to="/personal/orderrecord">历史订单</router-link>
				<span>|</span>
				<!--{{ nickname }}
				<span>|</span>-->
				<a @click="logout">退出登录</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'myheader',
	data () {
	    return {
	    	isLogin: false,
	    	api_token: "",
	    	nickname: "",
	    	is_nouser_version:sessionStorage.getItem('is_nouser_version') || '',
	    	system_web_name:sessionStorage.getItem('system_web_name') || '',
	    	is_haveteam_version:sessionStorage.getItem('is_haveteam_version') || '',//是否开放团体版，0没有团体版，1有团体版
	    	isLoginTeam:false
	    }
	},
	watch: {
		"$store.state.personal_api_token": function(val){
			let vm = this;
			vm.api_token = vm.$store.state.personal_api_token;
			vm.nickname = vm.$store.state.personal_nickname;
			if(vm.api_token || vm.nickname){
				vm.isLogin = true;
			}else{
				vm.isLogin = false;
			}
		},
		"$store.state.is_nouser_version": function(val){
			this.is_nouser_version = this.$store.state.is_nouser_version;
		},
		"$store.state.system_web_name": function(val){
			this.system_web_name = this.$store.state.system_web_name;
		},
		"$store.state.is_haveteam_version": function(val){
			this.is_haveteam_version = this.$store.state.is_haveteam_version;
		},
		"$store.state.api_token": function(val){
			let vm = this;
			vm.team_nickname = vm.$store.state.nickname;
			if(vm.$store.state.api_token || vm.$store.state.nickname){
				vm.isLoginTeam = true;
			}else{
				vm.isLoginTeam = false;
			}
		}
	},
	created () {
		let vm = this;
		vm.api_token = localStorage.getItem("personal_api_token");
		vm.nickname = localStorage.getItem("personal_nickname");
		if(vm.api_token || vm.nickname){
			vm.isLogin = true;
		}else{
			vm.isLogin = false;
		}
		vm.team_nickname = localStorage.getItem("nickname");
		if(localStorage.getItem("api_token") || localStorage.getItem("nickname")){
			vm.isLoginTeam = true;
		}else{
			vm.isLoginTeam = false;
		}
	},
	methods: {
		// 个人登录
		loginPer: function(){
			let vm = this;
			vm.$store.commit("showLogin",1);
		},
		// 团体登录
		loginTeam: function(){
			let vm = this;
			vm.$store.commit("showLogin",2);
		},
		// 团体预约
		teamOrder: function(){
			let vm = this;
			vm.$router.push({
				path: "/team/order"
			});
			if(!localStorage.getItem('api_token')){
				setTimeout(function(){
					vm.$store.commit("showLogin",2);
				},200)
			}
			
		},
		logout: function(){
			let vm = this;
			localStorage.removeItem("personal_api_token");
			localStorage.removeItem("personal_nickname");
			vm.$store.commit("logout");
			vm.$router.push({
				path: "/personal"
			})
			window.location.reload();
		},
		// 修改密码
		modifypwd: function(){
			this.$store.commit("showLogin",3);
		}
	}
}
</script>

<style scoped lang="scss">
@import "@/style/theme.scss";
@font-face {
	font-family: 'fzqk';
	src: url('../../../static/font/fzqk.ttf');
}
.header{
	height: 125px;
	position: relative;
	/*background: url(../../../static/img/head_bg.png) center top / 100% 100% #9E1F19;*/
	background: $base-color;
	.center{
		width: 1200px;
		height: 125px;
		margin: 0 auto;
		position: relative;
		.logo{
			width: auto;
			height: 60px;
			position: absolute;
			top: 32px;
			left: 0px;
			font-size: 30px;
			line-height: 60px;
			color: #fff;
			/*font-family: "fzqk";*/
			font-weight: bold;
			white-space: nowrap;
			cursor: pointer;
		}
		.logout, .login{
			width: auto;
			height: 30px;
			position: absolute;
			top: 47px;
			right: 0px;
			white-space: nowrap;
			color: #fff;
			font-size: 18px;
			line-height: 30px;
			a{
				margin: 0 15px;
				color: #fff;
				&:hover{
					font-weight: bold;
				}
			}
			span{
				font-size: 16px;
				line-height: 30px;
				color: #fff;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/common/personalHeader.vue